// The bottom sheet a word's ladder and the spelling keyboard lift in, as a
// modal dialog: composed from packages/ui's shadcn Sheet, which stays as the
// CLI wrote it, and dressed by compose.css's `.compose-sheet`. Focus moves
// in and stays in, the story behind is out of reach for pointer, keyboard
// and screen reader alike, Escape and the scrim close it, and focus goes
// back to whatever opened it. Every sheet names itself with a
// `ComposeSheetTitle`, visible or not.
import {
  Sheet,
  SheetContent,
  SheetTitle,
} from "@bindery/ui/components/ui/sheet";
import { cn } from "@bindery/ui/lib/utils";
import { type ReactNode, useLayoutEffect, useRef } from "react";

export const ComposeSheetTitle = SheetTitle;

export function ComposeSheet({
  className,
  onClose,
  children,
}: {
  readonly className?: string;
  readonly onClose: () => void;
  readonly children: ReactNode;
}) {
  // Taken before the dialog moves focus in: the story's words open a sheet
  // by state, so there is no trigger for Radix to hand focus back to.
  const opener = useRef<Element | null>(null);
  useLayoutEffect(() => {
    opener.current = document.activeElement;
  }, []);

  return (
    <Sheet
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <SheetContent
        side="bottom"
        showCloseButton={false}
        // Radix hides the page from assistive tech instead; saying so as
        // well costs nothing where hiding is not honoured.
        aria-modal
        aria-describedby={undefined}
        className={cn("compose-sheet compose", className)}
        style={{ background: "var(--paper)", minHeight: 0 }}
        onCloseAutoFocus={(event) => {
          event.preventDefault();
          const back = opener.current;
          if (back instanceof HTMLElement && back.isConnected) back.focus();
        }}
      >
        {children}
      </SheetContent>
    </Sheet>
  );
}
